import React, { useState } from "react";
import { Form, Select, Upload, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { useMutation } from "react-query";
import { uploadDocument, finalizeVerification } from "../modules/kyc/services/kycApi";
import toast from "react-hot-toast";

const { Dragger } = Upload;

const KycModal = ({ closeModal }) => {
    const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
    const [documentType, setDocumentType] = useState("CNI");
    const [kycData, setKycData] = useState(null);
    const [recto, setRecto] = useState(null);
    const [verso, setVerso] = useState(null);

    const uploadDocumentMutation = useMutation(uploadDocument);
    const finalizeVerificationMutation = useMutation(finalizeVerification);

    const uploadDocumentFunction = () => {
        const firstBody = {
            'category': 'cni',
            'file': kycData.recto,
            'token': currentUser?.token
        }
        const secondBody = {
            'category': 'cni',
            'file': kycData.verso,
            'token': currentUser?.token
        }

        uploadDocumentMutation.mutate(firstBody, {
            onSuccess: (firstResponse) => {
                setRecto(firstResponse.fileName);

                if (documentType == 'CNI') {
                    uploadDocumentMutation.mutate(secondBody, {
                        onSuccess: (secondResponse) => {
                            setVerso(secondResponse.fileName);

                            const finalizeObject = {
                                'documentType': documentType,
                                'filenameRecto': firstResponse.fileName,
                                'filenameVerso': secondResponse.fileName,
                                'token': currentUser?.token,
                                'merchantId': currentUser?.userId
                            }

                            finalizeVerificationMutation.mutate(finalizeObject, {
                                onSuccess: (response) => {
                                    toast.success("Documents envoyés avec succès");
                                    closeModal(false);
                                },
                                onError: (error) => {
                                    console.error("Error > ", error);
                                    toast.error("Erreur lors de l'envoie des documents");
                                    closeModal(false);
                                }
                            })
                        },
                        onError: (error) => {
                            console.error(error);
                        }
                    })
                } else {
                    const finalizeObject = {
                        'documentType': documentType,
                        'filenameRecto': firstResponse.fileName,
                        'filenameVerso': 'non-défini',
                        'token': currentUser?.token,
                        'merchantId': currentUser?.userId
                    }

                    finalizeVerificationMutation.mutate(finalizeObject, {
                        onSuccess: (response) => {
                            toast.success("Documents envoyés avec succès");
                            closeModal(false);
                        },
                        onError: (error) => {
                            console.error("Error > ", error);
                            toast.error("Erreur lors de l'envoie des documents");
                            closeModal(false);
                        }
                    });
                }

            },
            onError: (error) => {
                console.error("Error > ", error);
                toast.error("Erreur lors de l'envoie des documents");
                closeModal(false);

            }
        }
        );

    }

    const normFile = (e) => (Array.isArray(e) ? e : e?.fileList);
    return (
        <div className="mt-4">
            <div className="title-h3-kyc">Documents d’identité</div>

            <div className="mt-3 d-flex justify-content-center ">
                <Form.Item
                    label="Type de document"
                    layout="vertical"
                    style={{ width: "80%" }}
                    className="normal"
                >
                    <Select
                        value={documentType}
                        onChange={(value) => {
                            setDocumentType(value);
                            setKycData((prev) => ({ ...prev, type: value }));
                        }}
                        options={[
                            { value: "CNI", label: "Carte nationale d’identité" },
                            { value: "PASSPORT", label: "Passeport" },
                        ]}
                        placeholder="Sélectionnez un type"
                    />
                </Form.Item>
            </div>

            <div className="mt-2 d-flex justify-content-center">
                <Form.Item
                    label="Recto du document"
                    layout="vertical"
                    valuePropName="fileList"
                    getValueFromEvent={normFile}
                    className="text-normal"
                >
                    <Dragger
                        name="recto"
                        multiple={false}
                        beforeUpload={(file) => {
                            setKycData((prev) => ({ ...prev, recto: file }));
                            return false;
                        }}
                        accept=".jpg,.jpeg,.png,.pdf"
                        maxCount={1}
                        style={{
                            backgroundColor: "#FFFFFF",
                            width: "100%",
                            height: "148px",
                            borderRadius: "8px",
                            border: "2px dashed #E3E3E3",
                        }}
                    >
                        <InboxOutlined />
                        <div className="cliqued">
                            Cliquez pour télécharger ou glissez votre fichier
                        </div>
                        <div className="fichierType">PDF, JPG jusqu'à 10MB</div>
                    </Dragger>
                </Form.Item>
            </div>

            {
                documentType == "CNI" &&
                <div className="mt-2 d-flex justify-content-center">
                    <Form.Item
                        label="Verso du document"
                        layout="vertical"
                        valuePropName="fileList"
                        getValueFromEvent={normFile}
                        className="fichierType"
                    >
                        <Dragger
                            name="verso"
                            multiple={false}
                            beforeUpload={(file) => {
                                setKycData((prev) => ({ ...prev, verso: file }));
                                return false;
                            }}
                            accept=".jpg,.jpeg,.png,.pdf"
                            maxCount={1}
                            style={{
                                backgroundColor: "#FFFFFF",
                                width: "100%",
                                height: "148px",
                                borderRadius: "8px",
                                border: "2px dashed #E3E3E3",
                            }}
                        >
                            <InboxOutlined />
                            <div className="cliqued">
                                Cliquez pour télécharger ou glissez votre fichier
                            </div>
                            <div className="fichierType">PDF, JPG jusqu'à 10MB</div>
                        </Dragger>
                    </Form.Item>
                </div>
            }

            {/* Bouton Suivant */}
            <div className="d-flex justify-content-center row mt-4">
                <button className="btn btn-primary buttonSui" onClick={uploadDocumentFunction}>
                    Envoyer les documents
                </button>
            </div>
        </div>
    );
}

export default KycModal;